<template>
  <div class="new-bet-slip-content">
    <bet-slip-load v-if="showLoading" :betCount="betSlipBetCount"></bet-slip-load>
    <template v-else>
      <bet-alert-message v-if="betOptionsStatus.error" error withoutIcon :description="betOptionsStatus.error" />

      <template v-if="betSlipBetCount > 0">
        <straight-tab v-if="selectedType === 'straight'" ref="straightTab"></straight-tab>
        <parlay-tab v-if="selectedType === 'parlay'" ref="parlayTab"></parlay-tab>
        <teaser-tab v-if="selectedType === 'teaser'" ref="teaserTab"></teaser-tab>
        <round-robin-tab v-if="selectedType === 'round_robin' && betSlipBetCount > 2" ref="roundRobinTab"></round-robin-tab>
        <if-bet-tab v-if="selectedType === 'if_win' || selectedType === 'if_win_or_tie'" ref="ifBetTab"></if-bet-tab>
        <!-- <reverse-tab v-if="selectedType === 'reverse'" ref="reverseTab"></reverse-tab> -->
      </template>
      <div v-if="betSlipBetCount === 0" class="empty-bet-slip mt-1">
        {{ $t('BetSlip.EmptySlip') }}
      </div>
    </template>
    <!-- Login Need Modal -->
    <portal to="destination">
      <modal :closeable="true" v-if="showLoginNeedModal" @close="setShowLoginNeedModal(false)" type="danger">
        <div slot="body">
          <h2 class="text-center" v-if="isClerk">
            {{ $t('BetSlip.NeedScanBarcode') }}
          </h2>
          <h2 class="text-center" v-if="!isClerk && $isElectron">
            {{ $t('BetSlip.NeedLogin') }}
          </h2>
          <h2 class="text-center" v-if="!isClerk && !$isElectron">
            {{ $t('BetSlip.NeedLoginWeb') }}
          </h2>
          <div class="confirmation-wrapper">
            <template v-if="$isElectron">
              <router-link
                class="btn btn-large mt-3 btn-confirm"
                :to="{
                  name: 'login',
                  query: { redirect: $router.currentRoute.path },
                }"
                v-if="$store.getters['settings/canClerkLogin']"
                >{{ $t('Login') }}
              </router-link>

              <button class="btn btn-large mt-3 btn-confirm" @click="openBarcodeModal" v-else>
                {{ $t('BetSlip.Scan Barcode') }}
              </button>
            </template>
            <router-link
              class="btn btn-large mt-3 btn-confirm"
              :to="{
                name: 'login',
                query: { redirect: $router.currentRoute.path },
              }"
              v-else
              >{{ $t('Login') }}
            </router-link>
          </div>
        </div>
      </modal>
    </portal>
    <!-- Lines Disabled Modal -->
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import StraightTab from './StraightTab';
import ParlayTab from './ParlayTab';
import RoundRobinTab from './RoundRobinTab';
import IfBetTab from './IfBetTab';
import ReverseTab from './ReverseTab';
import TeaserTab from './TeaserTab';
import BetSlipConfirmation from './BetSlipConfirmation';
import LoadingIcon from '@/components/shared/LoadingIcon';
import { createBet } from './bet-slip-utils';
import { LoginTypes } from '@/utils/enums';
import BetSlipBetPlaceModal from './BetSlipBetPlaceModal';
import BetSlipBetPlaceModalLineChanged from './BetSlipBetPlaceModalLineChanged';
import BetSlipBetConfirmationModal from './BetSlipBetConfirmationModal';
import BetSlipLoad from './BetSlipLoad';
import { BDropdown, BDropdownItem, BDropdownHeader } from 'bootstrap-vue';
import BetSlipTabOptions from '@/views/sports/components/bet-slip/BetSlipTabOptions';

export default {
  components: {
    BetSlipTabOptions,
    StraightTab,
    ParlayTab,
    RoundRobinTab,
    IfBetTab,
    ReverseTab,
    TeaserTab,
    BDropdown,
    BDropdownItem,
    BDropdownHeader,
    BetSlipConfirmation,
    LoadingIcon,
    BetSlipBetPlaceModal,
    BetSlipBetPlaceModalLineChanged,
    BetSlipBetConfirmationModal,
    BetSlipLoad,
  },
  data() {
    return {
      isAdvanced: false,
      isShowBetTabs: false,
    };
  },
  computed: {
    ...mapState({
      betTabs: state => state.betSlip.betTabs,
      selectedType: state => state.betSlip.selectedType,
      selectedTypeName: state => state.betSlip.selectedTypeName,
      currentState: state => state.betSlip.currentState,
      betSlipBetCount: state => state.betSlip.betSlipBetCount,
      newBetSlipSelection: state => state.betSlip.newBetSlipSelection,
      betOptionsStatus: state => state.betSlip.betOptionsStatus,
      betConfirmationResponse: state => state.betSlip.betConfirmationResponse,
      betPlaceResponse: state => state.betSlip.betPlaceResponse,
      betPlaceStatus: state => state.betSlip.betPlaceStatus,
      selectedLocale: state => state.settings.selectedLocale,
      showLoginNeedModal: state => state.betSlip.showLoginNeedModal,
      showDisabledLinesModal: state => state.betSlip.showDisabledLinesModal,
      betConfirmationDisabledLines: state => state.betSlip.betConfirmationDisabledLines,
      loginType: state => state.player.loginType,
    }),
    showLoading() {
      return this.betOptionsStatus.loading;
    },
    isClerk() {
      return this.loginType === LoginTypes.Clerk;
    },
  },
  watch: {
    $route() {
      this.setShowLoginNeedModal(false);
      this.$store.commit('betSlip/closeBetSlip');
    },
  },
  methods: {
    ...mapActions({
      clearBetSlip: 'betSlip/clearBetSlip',
      placeBet: 'betSlip/placeBet',
      getNewBetOptions: 'betSlip/getNewBetOptions',
      closeDisableLinesModal: 'betSlip/closeDisableLinesModal',
      createOrUpdateBet: 'betSlip/createOrUpdateBet',
    }),
    ...mapMutations({
      setCurrentState: 'betSlip/setCurrentState',
      resetBetSlip: 'betSlip/resetBetSlip',
      setSelectedBetType: 'betSlip/setSelectedBetType',
      resetRiskAndWinAmounts: 'betSlip/resetRiskAndWinAmounts',
      setShowLoginNeedModal: 'betSlip/setShowLoginNeedModal',
    }),
    isLineChanged() {
      let isLineChanged = false;
      this.betPlaceResponse.map(row => {
        if (row.IsSuccess && row.ErrorMessageKey === 'GAMELINECHANGE') {
          isLineChanged = true;
        }
      });
      return isLineChanged;
    },
    openBarcodeModal() {
      this.setShowLoginNeedModal(false);
      this.$parent.showScanBarcodeModal = true;
    },
    messageListener(self) {
      return function(event) {
        if (event.data === 'BET_SLIP_FREE_WAGER_TRIGGER_RISK_CHANGE') {
          if (self.$refs.straightTab) self.$refs.straightTab.triggerRiskChangeForAllBets();
          if (self.$refs.parlayTab) self.$refs.parlayTab.triggerRiskChangeForAllBets();
          if (self.$refs.teaserTab) self.$refs.teaserTab.triggerRiskChangeForAllBets();
        }
      };
    },
    showBetTabs(value, $event) {
      this.isShowBetTabs = value;

      if ($event) {
        $event.stopPropagation();
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.messageListener(this));
  },
  created() {
    let myElementToCheckIfClicksAreInsideOf = this.$refs.betSlipTab;
    document.body.addEventListener('click', event => {
      this.isShowBetTabs = myElementToCheckIfClicksAreInsideOf === event;
    });
  },
  destroyed() {
    window.removeEventListener('message', this.messageListener);
  },
};
</script>
